import { defineStore } from 'pinia';
import { useRequestStore } from '@/features/requests/requests'

interface User {
  name: string;
  token: string;
  tokenTtl: number;
  tokenGot: number;
  refreshToken: string;
  avatar: string;
}

const STORAGE_KEY = 'user';

export const useUserStore = defineStore('user', {
  state: (): { user: User | null } => ({
    user: JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'),
    loading: false,
    stateText: '',
  }),

  actions: {
    setUser(payload: { name: string; token: string; refreshToken: string; tokenTtl: number; tokenGot: number; avatar: string, isDon: boolean, id: number }) {
      this.user = payload;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    },

    updateToken(token: string) {
      this.user.token = token;
      this.user.tokenGot = Math.floor(Date.now() / 1000) - 10;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.user));
    },

    async logout() {
      const requestStore = useRequestStore();
      this.loading = true;
      try {
        await requestStore.send('token/invalidate', {
          method: "POST",
          payload: { 'refresh_token': this.user.refreshToken },
          onlyWithAuth: true,
        });
      } catch (e) {
        console.error(`Не удалось инвалидировать токен.`, e)
      }
      this.localLogout();
      this.loading = false;
    },

    localLogout() {
      this.user = null;
      localStorage.removeItem(STORAGE_KEY);
    },

    async refreshToken() {
      const result = await fetch(`${window.APP_CONFIG.API_URL}/api/token/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'refresh_token': this.user.refreshToken,
        }),
      });

      if (!result.ok) {
        if (result.status === 401) {
          this.localLogout();
          return;
        }

        throw new Error("Ошибка при обновлении токена!")
      }

      const resultJson = await result.json();
      this.updateToken(resultJson.token);
    },

    initialize() {
      const stored = localStorage.getItem(STORAGE_KEY);
      this.user = stored ? JSON.parse(stored) : null;
    },

    async checkToken() {
      if (this.isAuth) {
        const currentTime = Math.floor(Date.now() / 1000);
        if (currentTime > this.user.tokenGot + Number(this.user.tokenTtl)) {
          await this.refreshToken();
        }
      }
    },

    setLoading(state: boolean): void
    {
      this.loading = state;
    },

    setStateText(stateText: string): void
    {
      this.stateText = stateText;
    }
  },

  getters: {
    isAuth: (state) => !!state.user,
    userName: (state) => state.user?.name ?? '',
    avatar: (state) => state.user?.avatar ?? '',
    isDon: (state) => state.user?.isDon ?? false,
    isLoading: (state) => state.loading,
    getStateText: (state) => state.stateText,
  },
});
